import classNames from "classnames";

export const evenBlock = (isDark: boolean): string => {
    return classNames(
        // Mobile
        isDark ? "mobile:flex-row" : "mobile:flex-col",
        isDark ? "mobile:text-left" : "mobile:text-center",
        "mobile:w-full",
        "mobile:justify-start",
        "mobile:ml-0",
        "mobile:mr-0",
        // Tablet
        "tablet:flex-row",
        "tablet:w-1/3",
        "tablet:justify-start",
        "tablet:text-left",
        "tablet:mr-5",
        "tablet:ml-5",
        // All
        "flex",
        "items-center",
        "mt-5",
        "mb-5",
        isDark ? "text-white" : "text-secondary"
    );
};

export const oddBlock = (isDark: boolean): string => {
    return classNames(
        // Mobile
        isDark ? "mobile:flex-row" : "mobile:flex-col",
        isDark ? "mobile:text-left" : "mobile:text-center",
        "mobile:w-full",
        "mobile:justify-start",
        // Tablet
        "tablet:flex-row",
        "tablet:w-1/3",
        "tablet:justify-start",
        "tablet:pl-5",
        // All
        "flex",
        "items-center",
        "mt-5",
        "mb-5",
        "max-w-[500px]",
        isDark ? "text-white" : "text-secondary"
    );
};
export const image = (isDark: boolean) => {
    return classNames(
        // Mobile
        isDark ? "mobile:mb-0" : "mobile:mb-2",
        isDark ? "mobile:w-1/4" : "mobile:w-28",
        isDark ? "mobile:mr-4" : "mobile:mr-0",
        // Tablet
        "tablet:w-40",
        "tablet:mb-0",
        "tablet:mr-4"
    );
};

export const content = (isDark: boolean) => {
    return isDark
        ? classNames(
            // Mobile
            "mobile:w-3/4",
            "mobile:text-left",
            // Tablet
            "tablet:w-auto",
            "tablet:text-left",
        )
        : "";
};

export const strong = classNames(
    // Mobile
    "mobile:text-lg",
    "mobile:text-left",
    "mobile:m-0",
    // tablet
    "tablet:text-xl",
    // All
    "font-semibold"
);
export const p = classNames(
    // Mobile
    "mobile:text-sm",
    // Tablet
    "tablet:text-base",
    "tablet:text-left",

    // All
    "font-thin",

);

export const linkedin = classNames(
    // Mobile
    "mobile:ml-2",
    // Tablet
    "tablet:ml-2",
    // All
    "w-4",
    "ml-4"

);
